import { useCallback } from "react";
import { ref, set } from "firebase/database";
import { db } from "../api/firebase";
import { useAuth } from "../helpers/Auth";

const useSharedActions = () => {
  const { effectiveUID } = useAuth();

  const sharedUserPath = () => `/shared_userdata/${effectiveUID}`;

  const createSharedProject = useCallback(
    (formProps: { id: string; [key: string]: any }) => {
      set(ref(db, sharedUserPath() + `/projects/${formProps.id}`), {
        ...formProps,
      });
    },
    [effectiveUID]
  );

  const createSharedFiring = useCallback(
    (formProps: { id: string; [key: string]: any }) => {
      const newProps = { ...formProps };
      set(ref(db, sharedUserPath() + `/firings/${formProps.id}`), {
        ...newProps,
      });
    },
    [effectiveUID]
  );

  const createSharedSegment = useCallback(
    (formProps: { id: string; [key: string]: any }) => {
      set(ref(db, sharedUserPath() + `/segments/${formProps.id}`), {
        ...formProps,
      });
    },
    [effectiveUID]
  );

  return { createSharedProject, createSharedFiring, createSharedSegment };
};

export default useSharedActions;
